<template>
  <c-calendar-base
    v-bind="{ ...$attrs, ...passThroughProps }"
    :value="modelValue"
    @input="$emit('update:modelValue', $event)"
    @drag="$emit('drag', $event)"
    @preselect="$emit('preselect', $event)"
  />
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import CCalendarBase from './index.vue?ignore-next=1'

const baseComponent = CCalendarBase?.default || CCalendarBase
const baseProps = baseComponent?.props
  || baseComponent?.options?.props
  || {}
const { value: _value, ...CCalendarBaseProps } = baseProps

export default {
  name: 'CCalendar',

  components: {
    CCalendarBase
  },

  inheritAttrs: false,

  props: {
    ...CCalendarBaseProps,
    modelValue: {
      type: [ Date, Array, Object, String ],
      default: null
    }
  },

  emits: [
    'update:modelValue',
    'drag',
    'preselect'
  ],

  computed: {
    passThroughProps () {
      const { modelValue, ...rest } = this.$props
      return rest
    }
  }
}
</script>
